import { GET_ALERTS } from '../../types'
import { trackPromise } from 'react-promise-tracker'
import log from 'loglevel'
import { parseResponse } from '@jweb-development/response-parser'
const api = (process.env.REACT_APP_ON_PREM === true || process.env.REACT_APP_ON_PREM === 'true') && window.location.protocol === 'http:' ? 'http://' + window.location.hostname + ':3080' : (process.env.REACT_APP_ON_PREM === true || process.env.REACT_APP_ON_PREM === 'true') && window.location.protocol === 'https:' ? 'https://' + window.location.hostname + ':8443' : process.env.REACT_APP_API_URL

// gets all alerts
export const getAlerts = (unitID, fireSuccess = () => {}, fireFailure = () => {}) => {
  return async function (dispatch, getState) {
    const { token, accountId, supervisorID } = getState().auth

    const options = {
      method: 'GET',
      mode: 'cors',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`
      }
    }

    const response = await window.fetch(`${api}/accounts/${accountId}/supervisors/${supervisorID}/unit/${unitID}/alerts`, options)
    const parsedResponse = parseResponse(response)

    if (parsedResponse && !parsedResponse.error) {
      const { data } = await response.json()

      dispatch({ type: GET_ALERTS, payload: data }); fireSuccess()
    } else {
      fireFailure()
    }
  }
}

// gets details for one alert
export const getAlertSettings = (unitID, alertID, handleDataSet) => {
  return async function (dispatch, getState) {
    const { token, accountId, supervisorID } = getState().auth

    const options = {
      method: 'GET',
      mode: 'cors',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`
      }
    }

    const response = await trackPromise(window.fetch(`${api}/accounts/${accountId}/supervisors/${supervisorID}/unit/${unitID}/alerts/${alertID}`, options))
    if (!response.status || response.status === 401 || response.status === 404 || response.status === 500) {
      log.warn('non 200 status from alerts')
    } else {
      const { data } = await response.json()
      log.debug(data)
      handleDataSet(data)
      // dispatch({
      //   type: GET_ALERTS,
      //   payload: data
      // })
    }
  }
}

// posts a new alert
export const postAlert = (alertData, unitID, fireSuccess, fireFailure) => {
  return async function (dispatch, getState) {
    const { token, accountId, supervisorID } = getState().auth

    const body = {
      emailNotificationName: alertData.emailNotificationName,
      emailNotificationDesc: alertData.emailNotificationDesc,
      type: alertData.type,
      keyboard: alertData.keyboard,
      application: alertData.application,
      limitByTimeframe: alertData.limitByTimeframe,
      timeframe: alertData.timeframe,
      count: alertData.count,
      resetCount: alertData.resetCount,
      groupByWorkstation: alertData.groupByWorkstation,
      groupByUser: alertData.groupByUser,
      privateAlert: alertData.privateAlert,
      minSeverity: alertData.minSeverity,
      maxSeverity: alertData.maxSeverity,
      categories: alertData.categories,
      words: alertData.words,
      usernames: alertData.usernames,
      workstations: alertData.workstations
    }

    const options = {
      method: 'POST',
      mode: 'cors',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`
      },
      body: JSON.stringify(body)
    }

    const response = await trackPromise(window.fetch(`${api}/accounts/${accountId}/supervisors/${supervisorID}/unit/${unitID}/alerts`, options))
    if (!response.status || response.status === 500 || response.status === 401 || response.status === 404 || response.status === 400) {
      fireFailure()
    } else {
      fireSuccess()
    }
  }
}

export const cloneAlert = (alertData, unitID, fireSuccess, fireFailure) => {
  return async function (dispatch, getState) {
    const { token, accountId, supervisorID } = getState().auth

    const cloneAlertID = alertData.clonedEmailNotificationID

    const body = {
      emailNotificationName: alertData.emailNotificationName,
      emailNotificationDesc: alertData.emailNotificationDesc,
      type: alertData.type,
      keyboard: alertData.keyboard,
      application: alertData.application,
      limitByTimeframe: alertData.limitByTimeframe,
      timeframe: alertData.timeframe,
      count: alertData.count,
      resetCount: alertData.resetCount,
      groupByWorkstation: alertData.groupByWorkstation,
      groupByUser: alertData.groupByUser,
      privateAlert: alertData.privateAlert,
      minSeverity: alertData.minSeverity,
      maxSeverity: alertData.maxSeverity,
      categories: alertData.categories,
      wordsToAdd: alertData.wordsToAdd,
      wordsToDelete: alertData.wordsToDelete,
      usernames: alertData.usernames,
      workstations: alertData.workstations
    }

    const options = {
      method: 'POST',
      mode: 'cors',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`
      },
      body: JSON.stringify(body)
    }

    const response = await trackPromise(window.fetch(`${api}/accounts/${accountId}/supervisors/${supervisorID}/unit/${unitID}/alerts/${cloneAlertID}/clone`, options))
    if (!response.status || response.status === 500 || response.status === 401 || response.status === 404 || response.status === 400 || response.status === 413) {
      fireFailure()
    } else {
      fireSuccess()
    }
  }
}

export const subscribeToAlert = (unitID, prefrences, fireSuccess, fireFailure) => {
  return async function (dispatch, getState) {
    const { token, accountId, supervisorID } = getState().auth

    const body = {
      emailNotificationID: prefrences.emailNotificationID,
      unitsToAdd: prefrences.unitsToAdd,
      unitsToDelete: prefrences.unitsToDelete,
      sendSMS: prefrences.sendSMS,
      sendEmail: prefrences.sendEmail,
      isSubscribed: prefrences.isSubscribed
    }
    const options = {
      method: 'PUT',
      mode: 'cors',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`
      },
      body: JSON.stringify(body)
    }

    const response = await trackPromise(window.fetch(`${api}/accounts/${accountId}/supervisors/${supervisorID}/unit/${unitID}/alerts/subscriptions`, options))
    if (!response.status || response.status === 500 || response.status === 401 || response.status === 404 || response.status === 400) {
      fireFailure()
    } else {
      const { data } = response.json
      log.debug(data)
      fireSuccess()
    }
  }
}

// updates an existing alert
export const updateAlert = (alertData, unitID, alertID, fireSuccess, fireFailure) => {
  return async function (dispatch, getState) {
    const { token, accountId, supervisorID } = getState().auth

    const body = {
      emailNotificationName: alertData.emailNotificationName,
      emailNotificationDesc: alertData.emailNotificationDesc,
      type: alertData.type,
      keyboard: alertData.keyboard,
      application: alertData.application,
      limitByTimeframe: alertData.limitByTimeframe,
      timeframe: alertData.timeframe,
      count: alertData.count,
      resetCount: alertData.resetCount,
      groupByWorkstation: alertData.groupByWorkstation,
      groupByUser: alertData.groupByUser,
      privateAlert: alertData.privateAlert,
      minSeverity: alertData.minSeverity,
      maxSeverity: alertData.maxSeverity,
      categories: alertData.categories,
      words: alertData.words,
      usernames: alertData.usernames,
      workstations: alertData.workstations,
      clonedAlert: alertData.clonedAlert,
      wordsToAdd: alertData.wordsToAdd,
      wordsToDelete: alertData.wordsToDelete
    }

    const options = {
      method: 'PUT',
      mode: 'cors',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`
      },
      body: JSON.stringify(body)
    }

    const response = await trackPromise(window.fetch(`${api}/accounts/${accountId}/supervisors/${supervisorID}/unit/${unitID}/alerts/${alertID}`, options))
    if (!response.status || response.status === 500 || response.status === 401 || response.status === 404 || response.status === 400) {
      fireFailure()
    } else {
      const { data } = response.json
      log.debug(data)
      fireSuccess()
    }
  }
}

// deletes an existing alert
export const deleteAlert = (unitID, alertID, orgAlert, fireDeleteSuccess, fireDeleteFailure) => {
  return async function (dispatch, getState) {
    const { token, accountId, supervisorID } = getState().auth

    const options = {
      method: 'DELETE',
      mode: 'cors',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`
      }
    }

    const responseDel = await trackPromise(window.fetch(`${api}/accounts/${accountId}/supervisors/${supervisorID}/unit/${unitID}/alerts/${alertID}/${orgAlert}`, options))
    const parsedResponse = parseResponse(responseDel)

    if (parsedResponse && !parsedResponse.error) {
      fireDeleteSuccess()
    } else {
      fireDeleteFailure()
    }
  }
}
